import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SalesQuoteIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SalesQuote",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M17.45 13.69c.32-.32.54-.75.54-1.18s-.21-.86-.54-1.07c-.21-.11-.43-.32-.64-.43v3c.32 0 .54-.11.64-.32M14.66 7.58c0 .32.11.64.32.75s.32.21.54.32V6.5c-.21 0-.32.11-.43.21-.32.21-.43.54-.43.86Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M24.42 2H7.47C5.32 2 3.61 3.72 3.61 5.86v20.28c0 2.15 1.72 3.86 3.86 3.86h17.06c2.15 0 3.86-1.72 3.86-3.86V5.86C28.28 3.71 26.57 2 24.42 2M13.8 12.3c.21.54.43 1.07.86 1.5.32.21.64.32.97.32v-3.65c-.75-.21-1.39-.64-1.93-1.07s-.75-1.07-.75-1.72c0-.32.11-.64.21-.86.11-.32.32-.54.54-.75s.54-.43.86-.54c.32-.21.75-.32 1.18-.43V4.03c0-.21.21-.43.43-.32h.54c.21 0 .43.11.43.32V5.1c.54.11 1.07.21 1.5.54.54.32.86.75 1.18 1.18.11.64-.86 1.29-1.72.64-.32-.32-.64-.64-1.07-.86v2.68c.43.21.75.32 1.07.54s.64.43.97.64c.54.54.97 1.29.86 2.04 0 .75-.32 1.5-.86 2.04-.54.64-1.29.97-2.15 1.18v.86c0 .21-.21.43-.43.32h-.54c-.21 0-.43-.11-.43-.32v-.86c-.86-.11-1.72-.43-2.36-.86a3.36 3.36 0 0 1-1.18-2.15c-.11-.75 1.39-1.18 1.82-.43Zm9.87 14.27H8.65c-.64 0-1.07-.43-1.07-1.07s.43-1.07 1.07-1.07h15.02c.64 0 1.07.43 1.07 1.07 0 .54-.43 1.07-1.07 1.07m0-5.15H8.65c-.64 0-1.07-.43-1.07-1.07s.43-1.07 1.07-1.07h15.02c.64 0 1.07.43 1.07 1.07s-.43 1.07-1.07 1.07"
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M24.29 29.29h-16c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43h16c1.89 0 3.43 1.54 3.43 3.43v20.57c0 1.89-1.54 3.43-3.43 3.43m-16-25.15c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h16c.63 0 1.14-.51 1.14-1.14V5.29c0-.63-.51-1.14-1.14-1.14h-16Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M17.43 21.29h-4.57a1.14 1.14 0 1 1 0-2.28h4.57a1.14 1.14 0 1 0 0-2.28h-2.29c-1.89 0-3.43-1.54-3.43-3.43s1.54-3.43 3.43-3.43h4.57a1.14 1.14 0 1 1 0 2.28h-4.57a1.14 1.14 0 1 0 0 2.28h2.29c1.89 0 3.43 1.54 3.43 3.43s-1.54 3.43-3.43 3.43"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.29 23.57c-.63 0-1.14-.51-1.14-1.14v-2.29a1.14 1.14 0 1 1 2.28 0v2.29c0 .63-.51 1.14-1.14 1.14M16.29 12.14c-.63 0-1.14-.51-1.14-1.14V8.71a1.14 1.14 0 1 1 2.28 0V11c0 .63-.51 1.14-1.14 1.14"
      })]
    })
  }));
};
SalesQuoteIcon.displayName = 'SalesQuoteIcon';